import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const createCheckoutSession = async (subscriptionData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }

    const { lookupKey, currencyCode } = subscriptionData

    const requestData = {
        lookupKey: lookupKey,
        currencyCode: currencyCode,
    }

    const response = await axios.post(baseUrl + `/api/users/subscriptions/createCheckoutSession`, requestData, config)

    // console.log(response)
    return response.data
}

const createPortalSession = async (subscriptionData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }

    const { stripeCustomerId } = subscriptionData

    const requestData = {
        stripeCustomerId: stripeCustomerId,
    }

    const response = await axios.post(baseUrl + `/api/users/subscriptions/createPortalSession`, requestData, config)

    // console.log(response)
    return response.data
}

const subscriptionService = {
    createCheckoutSession,
    createPortalSession,
}

export default subscriptionService